module.exports = __webpack_public_path__ + "img/pic12.301e1746.jpg";